import { Box, Typography } from '@mui/material';

import { Button } from '@/components';
import {
  useAddRecoveryEmailMutation,
  useFetchRecoveryEmailQuery,
} from '@/store';
import { SnackbarUtils } from '@/utils';

export const ConfirmRecoveryEmail = () => {
  const { data: recoveryEmail } = useFetchRecoveryEmailQuery();
  const [submit] = useAddRecoveryEmailMutation();
  return recoveryEmail?.verificationStatus === 'unverified' ? (
    <Box
      sx={{
        mt: 4,
        borderRadius: 2,
        bgcolor: '#FBE4B366',
        p: 2,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
      }}>
      <Box
        sx={{
          width: '10px',
        }}>
        <Box
          sx={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            bgcolor: 'red',
          }}
        />
      </Box>
      <Box>
        <Typography variant="body2">
          <strong>Confirm Recovery Email</strong>
          <br />
          We&apos;ve sent a confirmation email to:{' '}
          <strong>{recoveryEmail.recoveryEmail}</strong>. Click the link inside
          to verify your recovery email address.
        </Typography>
        <Box sx={{ width: '100%', mt: 2 }}>
          <Button
            variant="gradientPrimary"
            label="Resend Email"
            fullWidth={false}
            sx={{ float: 'right' }}
            onClick={async () => {
              try {
                await submit({
                  recoveryEmail: recoveryEmail.recoveryEmail,
                }).unwrap();
                SnackbarUtils.success(
                  'Recovery email resent successfully. Please check your inbox.',
                );
              } catch {
                SnackbarUtils.error(
                  'Something went wrong. Please try again or contact support.',
                );
              }
            }}
          />
        </Box>
      </Box>
    </Box>
  ) : null;
};
